export default [[amount => +amount >= 0.02, 'Amount should be more then 0']]
